/**
 * SO# Search 向け AppStatePatch 生成（React 非依存）。
 */
import { mergeRepeaterLinesAfterRegister } from './gen1ApplicationRepeaterMerge';
import { isSearchAddRepeaterLine } from '../gen1RepeaterLineHelpers';

export function buildSearchSuccessAppStatePatch(searchPatch) {
    return {
        repeaterSerials: searchPatch.remainingLines,
        trunkingItemPatch: {
            RepeaterQty: searchPatch.repeaterQty,
        },
    };
}

export function buildRegisterSearchRepeaterAppStatePatch(
    prev,
    salesOrderNumber,
    items
) {
    const prevLines = prev.gen1Order?.Gen1TrunkingOrderRepeaterSerials ?? [];
    const { lines, repeaterQty } = mergeRepeaterLinesAfterRegister(
        prevLines,
        salesOrderNumber,
        items
    );
    return {
        addRepeater: true,
        repeaterSerials: lines,
        trunkingItemPatch: {
            RepeaterQty: repeaterQty,
        },
    };
}

/**
 * Search 由来 ADD 行を 1 行削除する patch と削除行を返す。
 * @returns {{ patch: Object, deletedLine: Object|null }}
 */
export function buildDeleteSearchRepeaterLineAppStatePatch(
    prev,
    lineSequenceNumber
) {
    const serials = prev.gen1Order?.Gen1TrunkingOrderRepeaterSerials ?? [];
    const deletedLine =
        serials.find(
            (l) =>
                l.LineSequenceNumber === lineSequenceNumber &&
                isSearchAddRepeaterLine(l)
        ) ?? null;
    const nextSerials = serials.filter(
        (line) =>
            !(
                line.LineSequenceNumber === lineSequenceNumber &&
                isSearchAddRepeaterLine(line)
            )
    );
    const currentQty = Math.max(
        0,
        Number(prev.gen1Order?.Gen1TrunkingOrderItem?.RepeaterQty) || 0
    );
    return {
        patch: {
            repeaterSerials: nextSerials,
            trunkingItemPatch: {
                RepeaterQty: Math.max(0, currentQty - 1),
            },
        },
        deletedLine,
    };
}

/** Sales Order Number (SO#) 入力欄の validationErrors.orderNumber を設定する patch */
export function buildOrderNumberValidationErrorAppStatePatch(message) {
    return {
        validationErrorsPatch: {
            orderNumber: message,
        },
    };
}

/** Sales Order Number (SO#) 入力欄の validationErrors.orderNumber をクリアする patch */
export function buildClearOrderNumberValidationErrorAppStatePatch() {
    return {
        validationErrorsPatch: {
            orderNumber: undefined,
        },
    };
}
